import { Box } from "@material-ui/core";
import { useMemo } from "react";
import AreaChart from "src/components/ScoringChart/AreaChart";
import { baseBeautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import { numberWithCommas, toFixed } from "src/services/utils";

export default function CreditScoreStrategyChart({ seriesChart, dataChart }) {
  const options = {
    yAxis: {
      tickAmount: 6,
      labels: {
        enabled: true,
      },
    },
    xAxis: {
      tickInterval: 30,
      categories: dataChart?.timestamps,
    },
    ...baseBeautifulTooltip(
      (value) => numberWithCommas(toFixed(value, 2)),
      false,
      (x) => {
        return Math.floor(x) + "days " + ((x - Math.floor(x)) * 24).toFixed(0) + "h";
      }
    ),
  };

  const series = useMemo(() => {
    if (seriesChart) {
      return [{ name: "Credit Score", data: dataChart.credit_scores }];
    } else return [{ name: "Credit Score", data: [] }];
  }, [seriesChart]);

  return (
    <Box mt={4} p={2}>
      <AreaChart series={series} option={options} />
    </Box>
  );
}
